import React from "react";
import {
  UncontrolledButtonDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import "./DropDown.css";

const Devplan = (props) => {




  const isDisabled =
    !props.devPlan ||
    props.devPlanList.length === 0 ||
    (props.assessmentDetails && !props.assessmentDetails.enable_report);

  return (
    <React.Fragment>
      {isDisabled ? (
        <div>
          <DropdownToggle className="disabled">DOWNLOAD DEV PLAN</DropdownToggle>
          <DropdownMenu>
            {props.devPlanList &&
              props.devPlanList.map((items, index) => {
                return (
                  <div key={index}>
                    <DropdownItem className="download-Dropdownitem">
                      {items.relation_group_name}
                    </DropdownItem>
                  </div>
                );
              })}
          </DropdownMenu>
        </div>
      ) : (
        <UncontrolledButtonDropdown>
          <DropdownToggle caret className="download-DropdownToggle">
            DOWNLOAD DEV PLAN
          </DropdownToggle>
          <DropdownMenu>
            {props.devPlanList &&
              props.devPlanList.map((items, index) => {
                return (
                  <div key={index}>
                    <DropdownItem
                      className="download-Dropdownitem"
                      onClick={() =>
                        props.assessmentDetails &&
                        props.assessmentDetails.instrument__instrument_name === "LOI-Self"
                          ? props.handleSelfDevPlanDownload(
                              props.assessmentDetails.id,
                              props.assessmentDetails.participant__id,
                              items.id,
                              items.development_plan_name
                            )
                          : props.handleDevPlanDownload(
                              props.assessmentDetails.id,
                              props.assessmentDetails.participant__id,
                              items.id,
                              items.development_plan_name
                            )
                      }
                    >
                      {items.development_plan_name}
                    </DropdownItem>
                  </div>
                );
              })}
          </DropdownMenu>
        </UncontrolledButtonDropdown>
      )}
    </React.Fragment>
  );
};

export default Devplan;


// WEBPACK FOOTER //
// ./src/new/Components/Reports/Download-Reports/DropDown/Devplan-dropdown.jsx